/**
 * StartNode - Entry point node for workflows
 * Only one Start node allowed per workflow
 */

import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import type { StartNodeData } from '../../../../stores/workflow/types';

interface StartNodeProps {
  data: StartNodeData;
  selected?: boolean;
}

export const StartNode = memo(({ data, selected }: StartNodeProps) => {
  return (
    <div
      className={`
        flex min-w-[120px] flex-col items-center rounded-full border-2 bg-gradient-to-br
        from-green-400 to-green-600 px-6 py-4 shadow-lg transition-all
        ${selected ? 'border-green-300 ring-4 ring-green-200/50' : 'border-green-500'}
      `}
    >
      {/* Icon */}
      <div className='mb-1 text-white'>
        <svg className='h-6 w-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z'
          />
          <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M21 12a9 9 0 11-18 0 9 9 0 0118 0z' />
        </svg>
      </div>

      {/* Label */}
      <div className='text-sm font-bold text-white'>{data.label || 'Start'}</div>

      {/* Output Handle (bottom) */}
      <Handle type='source' position={Position.Bottom} className='!h-3 !w-3 !border-2 !border-white !bg-green-400' />
    </div>
  );
});

StartNode.displayName = 'StartNode';
